import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { WEB_COMPONENT_GZ_LABEL_SWITCH, WEB_COMPONENT_GZ_TITLE } from '../../webcomponents.constants';
import { GzLabelSwitchWebComponent } from '../../ui/gzLabelSwitch';
import { PhasrSidePanelEvents, PhasrPanelComponentTypes, PhasrSidePanelViewData, SwitchToggleValues } from '../types/types';
import { PhasrListWebComponent } from '../../phasrRecommendations/phasrList';
import { toggleVisibility } from '../../utils/htmlElement.utils';
import { translateFn } from '../../utils/translator.helper';
import { GzButtonWebComponent } from '../../ui/gzButton';
import { GzInputSearchWebComponent } from '../../ui/gzInput';

export class PhasrSidePanelView extends BaseWebComponentView {
  public dom: {
    $title: HTMLElement;
    $labelSwitch: GzLabelSwitchWebComponent;
    $firstList: PhasrListWebComponent;
    $secondList: PhasrListWebComponent;
    $searchContainer: HTMLElement;
    $firstSearchInput: GzInputSearchWebComponent;
    $secondSearchInput: GzInputSearchWebComponent;
    $backButton: GzButtonWebComponent;
    $backButtonText: HTMLElement;
    $actionButtonsContainer: HTMLElement;
    $firstActionButton: GzButtonWebComponent;
  };

  getDomElements(): void {
    this.dom = {
      $title: this.shadow.querySelector(WEB_COMPONENT_GZ_TITLE),
      $labelSwitch: this.shadow.querySelector(WEB_COMPONENT_GZ_LABEL_SWITCH),
      $firstList: this.shadow.querySelector('#firstList'),
      $secondList: this.shadow.querySelector('#secondList'),
      $searchContainer: this.shadow.querySelector('#searchContainer'),
      $firstSearchInput: this.shadow.querySelector('#firstSearchInput'),
      $secondSearchInput: this.shadow.querySelector('#secondSearchInput'),
      $backButton: this.shadow.querySelector('#backButton'),
      $backButtonText: this.shadow.querySelector('#backButtonText'),
      $actionButtonsContainer: this.shadow.querySelector('#actionButtonsContainer'),
      $firstActionButton: this.shadow.querySelector('#firstActionButton'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  setTranslatedStrings() {}

  buildSuccessView(data: PhasrSidePanelViewData): void {
    this.dom.$title.innerHTML = data.titleText;
    if (data.hasBackButton) {
      this.dom.$backButtonText.innerText = translateFn('Back');
      toggleVisibility(this.dom.$backButton as HTMLElement, true);
    }
    switch (data.componentType) {
      case PhasrPanelComponentTypes.BehavioralProfiles:
        this.buildBehavioralProfilesView();
        break;
      case PhasrPanelComponentTypes.BehavioralProfilesNoToggle:
        this.buildBehavioralProfilesNoToggleView();
        break;
      case PhasrPanelComponentTypes.RestrictedBehavioralProfiles:
        this.buildRestrictedBehavioralProfilesView();
        break;
      case PhasrPanelComponentTypes.RuleTriggers:
        this.buildRuleTriggersView();
        break;
      default:
        break;
    }

    this.dom.$firstList.dispatchEvent(
      new CustomEvent(PhasrSidePanelEvents.ViewSet)
    );
  }

  buildRuleTriggersView(): void {
    //search container
    toggleVisibility(this.dom.$searchContainer, true);

    //phasr list
    toggleVisibility(this.dom.$firstList, true);
  }
  buildBehavioralProfilesView(): void {
    //label switch
    toggleVisibility(this.dom.$labelSwitch, true);
    this.dom.$labelSwitch.itemLeft = {
      label: translateFn('Not using such tools'),
      value: SwitchToggleValues.NotUsingTools,
      checked: true,
    };
    this.dom.$labelSwitch.itemRight = {
      label: translateFn('Using such tools'),
      value: SwitchToggleValues.UsingTools,
      checked: false,
    };

    //search container
    toggleVisibility(this.dom.$searchContainer, true);
    this.dom.$firstSearchInput.placeholder = translateFn('Search behavioral profiles');
    this.dom.$secondSearchInput.placeholder = translateFn('Search behavioral profiles');

    //phasr list
    toggleVisibility(this.dom.$firstList, true);
  }

  buildBehavioralProfilesNoToggleView(): void {
    toggleVisibility(this.dom.$labelSwitch, false);

    toggleVisibility(this.dom.$searchContainer, true);
    this.dom.$firstSearchInput.placeholder = translateFn('Search behavioral profiles');

    toggleVisibility(this.dom.$firstList, true);
  }

  buildRestrictedBehavioralProfilesView(): void {
    //label switch
    toggleVisibility(this.dom.$labelSwitch, true);
    this.dom.$labelSwitch.itemLeft = {
      label: translateFn('Autopilot'),
      value: SwitchToggleValues.Autopilot,
      checked: true,
    };
    this.dom.$labelSwitch.itemRight = {
      label: translateFn('Direct control'),
      value: SwitchToggleValues.DirectControl,
      checked: false,
    };
    toggleVisibility(this.dom.$searchContainer, true);
    toggleVisibility(this.dom.$firstList, true);

    //action buttons
    this.dom.$firstActionButton.innerText = translateFn('Edit Access');
    toggleVisibility(this.dom.$actionButtonsContainer, true);
  }
}
